<template lang="pug">
  RouterLink.wt-router-link(
    :to="{ name: to, params }"
    :class="routerLinkStyleClasses"
  )
    slot
    slot(name='icon')
    span(v-if="text") {{ text }}

</template>

<script>
export default {
  name: "WtRouterLink",

  props: {
    text: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: "MyDashboard"
    },
    params: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: "default"
    }
  },

  computed: {
    /**
     * The "default" WtRouterlink - used in footers, text, etc.
     */
    isdefault() {
      return this.type === "default";
    },

    defaultClasses() {
      return "has-text-underlined";
    },

    /**
     * The "table" WtRouterlink - used in tables, etc.
     */
    isTable() {
      return this.type === "table";
    },

    tableClasses() {
      return "has-text-grey-dark";
    },

    /**
     * The "list" WtRouterlink - used in entity lists, etc.
     */
    isList() {
      return this.type === "list";
    },

    listClasses() {
      return "";
    },

    routerLinkStyleClasses() {
      const typeClasses = {
        list: this.listClasses,
        table: this.tableClasses,
        default: this.defaultClasses
      };

      return typeClasses[this.type];
    }
  }
};
</script>

<style lang="sass" scoped></style>
